// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Home(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Home" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Home.js.map